import React from 'react';

// importação do material
import { Typography } from '@material-ui/core';

// importação de mídia
import Success from "../../../images/check-circle.svg";
import Erro from "../../../images/error.svg";

const message = (props) => {

  const {
    tipo = "sucesso",
  } = props;

  return (
    <>
      {tipo === "sucesso" ?
        <>
          <div style={{ padding: '16px 12px', backgroundColor: '#C2EFD1', borderRadius: 4, display: 'flex' }}>
            <img src={Success} width={32} height={32} alt="" />
            <div style={{ marginLeft: 12 }}>
              <Typography style={{ fontSize: 16, fontWeight: 'bold', color: '#00662A' }}>Formulário enviado com sucesso!</Typography>
            </div>
          </div>
        </>
        :
        <>
          <div style={{ padding: '16px 12px', backgroundColor: '#FFEAE5', borderRadius: 4, display: 'flex' }}>
            <img src={Erro} width={32} height={32} alt=""/>
            <div style={{ marginLeft: 12 }}>
              <Typography style={{ fontSize: 16, fontWeight: 'bold', color: '#B22400' }}>Ops, tem alguma coisa errada.</Typography>
              <Typography style={{ fontSize: 13, color: '#394D60' }}>Os campos marcados em vermelho estão errados. Corrija os erros e envie o formulário.</Typography>
            </div>
          </div>
        </>}
    </>
  );
}

export default message;
